//Copyright (c) 2022 Panshak Solomon

import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import SnackbarProvider from "react-simple-snackbar";
import Home from "./components/Home/Home";
import Invoice from "./components/Invoice/Invoice";
import Invoices from "./components/Invoices/Invoices";
import InvoiceDetails from "./components/InvoiceDetails/InvoiceDetails";
import ClientList from "./components/Clients/ClientList";
import SupplierList from "./components/Suppliers/SuppliersList";
import NavBar from "./components/NavBar/NavBar";
import Login from "./components/Login/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Settings from "./components/Settings/Settings";
import Forgot from "./components/Password/Forgot";
import Reset from "./components/Password/Reset";
import Calendar from "./components/Meetings/Calendar";
import ItemsList from "./components/Items/ItemsList";
import MeetingForm from "./components/Meetings/MeetingForm";
import Meetings from "./components/Meetings/Meetings";
import AdminLogin from "./admin/adminLogin/adminLogin";
import AdminDashboard from "./admin/adminDashboard";
import AdminProfiles from "./admin/adminProfiles";
import Stats from "./admin/stats";
import UserStats from "./admin/userStats";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TodayBookings from "./components/TodayBookings/TodayBookings";
import Statement from "./admin/adminLogin/Statement";
import backgroundImage from "./assets/background.jpg";
import Subscription from "./components/SubscriptionComponent/Subscription";
import SuperAdminNavBar from "./components/NavBar/SuperAdminNavBar";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.js";

// import { requestFirebaseNotificationPermission } from './firebaseInit'

// import AdminOrders from './admin/adminOrders';
function App() {
  const user = JSON.parse(localStorage.getItem("profile"));
  const isSuperAdmin = user?.result?.userType === "superAdmin";

  // requestFirebaseNotificationPermission()
  //   .then((firebaseToken) => {
  //     // eslint-disable-next-line no-console
  //     console.log(firebaseToken);
  //   })
  //   .catch((err) => {
  //     return err;
  //   });

  // SuperAdmin Layout - Only shows Subscription management
  if (user && isSuperAdmin) {
    return (
      <div>
        <BrowserRouter>
          <SnackbarProvider>
            <SuperAdminNavBar />
            <Switch>
              <Route path="/login" exact component={Login} />
              <Route path="/" exact component={Login} />
              <ProtectedRoute
                path="/Subscribers"
                exact
                component={Subscription}
              />
              {/* Redirect any other route to Subscribers for superAdmin */}
              <Redirect to="/Subscribers" />
            </Switch>
          </SnackbarProvider>
        </BrowserRouter>
      </div>
    );
  }

  // Regular User/Admin Layout
  return (
    <div>
      <BrowserRouter>
        <SnackbarProvider>
          <NavBar />
          <main>
            <Header />
            <Switch>
              <Route path="/login" exact component={Login} />
              <Route path="/forgot" exact component={Forgot} />
              <Route path="/reset/:token" exact component={Reset} />

              <Route path="/" exact component={Login} />
              <ProtectedRoute path="/invoice" exact component={Invoice} />

              <ProtectedRoute
                path="/edit/invoice/:id"
                exact
                component={Invoice}
              />

              <ProtectedRoute
                path="/invoice/:id"
                exact
                component={InvoiceDetails}
              />

              <ProtectedRoute path="/invoices" exact component={Invoices} />

              <ProtectedRoute path="/admin" exact component={AdminLogin} />
              <ProtectedRoute path="/settings" exact component={Settings} />
              <ProtectedRoute path="/dashboard" exact component={Dashboard} />

              <ProtectedRoute
                path="/adminDashboard"
                exact
                component={AdminDashboard}
              />

              <ProtectedRoute
                path="/adminProfiles"
                exact
                component={AdminProfiles}
              />

              <ProtectedRoute path="/stats/:invoiceId" exact component={Stats} />

              <ProtectedRoute
                path="/userStats/:userId"
                exact
                component={UserStats}
              />

              <ProtectedRoute path="/meetings" exact component={Meetings} />
              <ProtectedRoute path="/customers" exact component={ClientList} />
              <ProtectedRoute path="/suppliers" exact component={SupplierList} />
              <ProtectedRoute path="/statement" exact component={Statement} />
              <ProtectedRoute path="/ItemsList" exact component={ItemsList} />
              <Route
                path="/Webview/PrivacyPolicy"
                exact
                component={PrivacyPolicy}
              />
              {user && <Redirect exact from="/new-invoice" to="/invoice" />}
              <ProtectedRoute
                path="/Subscribers"
                exact
                component={Subscription}
              />
              <ProtectedRoute
                path="/todayBookings"
                exact
                component={TodayBookings}
              />
            </Switch>
            <Footer />
          </main>
        </SnackbarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
